<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "SonstigesList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Sonstige Informationen & Dokumente"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category=6
      :event-to-call-options="{
        table: tableItems,
        showPath: 'Sonstiges',
        redirectPath: 'SonstigesEdit',
        categoryId: 6,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'sonstiges'
      }"
   new-button-path="SonstigesNew"></CMSListCard>
</template>

<style scoped>

</style>
